import TR from 'utils/TR';
import useNavAction from 'hooks/actions/useNavAction';
import T from 'utils/T';
import ex from 'utils/ex';
import FocusableButton from 'components/common/FocusableButton';

export default function SimulationNavButton(props) {
  const {
    triggered,
    onTrigger,
  } = useNavAction('Simulation', props);
  return (
    <FocusableButton {...ex(['NavButton', 'SimulationNavButton', { triggered }], props)} {...{ onClick: onTrigger() }}>
      <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_76_955)">
          <path d="M10.4 25L9 23.6L15.9 16.675L19.4 20.175L24.575 15L26 16.425L19.4 23L15.9 19.5L10.4 25ZM7 24C6.45 24 5.97917 23.8042 5.5875 23.4125C5.19583 23.0208 5 22.55 5 22V8C5 7.45 5.19583 6.97917 5.5875 6.5875C5.97917 6.19583 6.45 6 7 6H21C21.55 6 22.0208 6.19583 22.4125 6.5875C22.8042 6.97917 23 7.45 23 8V12.2H7V24ZM7 10.2H21V8H7V10.2Z" fill="#B7B7B7" />
        </g>
        <defs>
          <clipPath id="clip0_76_955">
            <rect width={24} height={24} fill="white" transform="translate(4 4)" />
          </clipPath>
        </defs>
      </svg>
      {T('AI Simulation')}
    </FocusableButton>
  );
}
